module.exports = __webpack_public_path__ + "media/site_templates/www.furnituremovingservices.com.au/images/our_services_3-2cd68b3826ab6f2ffbe091595e2516fc.jpg";